import { Selector } from "@ngxs/store";
import { ExtraOptionsState, ExtraOptionsStateModel } from "./extra-options.state";

export class ExtraOptionsGetterState {
  @Selector([ExtraOptionsState])
  static getExtraOptions(state: ExtraOptionsStateModel) {
    return state.ids.map(id => state.entities[id]);
  }
}